module.exports = __webpack_public_path__ + "img/prize-04.fd5a9fb3.png";